import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { DraftedShipments } from '@uturn/portal/modules/shipments';
import {
	SHIPMENTS_SEARCH_DEFAULT_STATUSES_DRAFTED,
	ShipmentsSearchSchema,
	ShipmentsSearchStatusesSchema,
} from '@uturn/portal/router/schema/shipments-search';

const DraftedShipmentsSearchSchema = ShipmentsSearchSchema.extend({
	'filter.statuses': fallback(
		ShipmentsSearchStatusesSchema.array(),
		SHIPMENTS_SEARCH_DEFAULT_STATUSES_DRAFTED,
	).default(SHIPMENTS_SEARCH_DEFAULT_STATUSES_DRAFTED),
});

export const Route = createFileRoute(
	'/_protected/shipments/(overview)/drafted',
)({
	component: DraftedShipments,
	validateSearch: zodValidator(DraftedShipmentsSearchSchema),
});
